import React from 'react'

import Need2Know from './Need2Know'
// _need2know: { ...fldCommProps, desc: '须知', title: null, content: '', delay: 0 },


const renderNeed2Know = config => {
	const { field: { key } } = config
	return <Need2Know key={key} config={config} />
}

export default renderNeed2Know